document.addEventListener('DOMContentLoaded', function () {
  const variantData = document.querySelector('[data-product-id]');
  if (!variantData) return;

  document.addEventListener('change', function (e) {
    if (!e.target.matches('[name="id"]')) return;

    const variantId = e.target.value;
    fetch(window.location.pathname + '?variant=' + variantId + '&section_id=' + document.querySelector('[data-section-id]')?.dataset.sectionId)
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newDesc = doc.querySelector('.variant-description');
        const currentDesc = document.querySelector('.variant-description');
        if (currentDesc && newDesc) {
          currentDesc.innerHTML = newDesc.innerHTML;
        } else if (currentDesc) {
          currentDesc.innerHTML = '';
        }
      });
  });
});
